import React, { useState, useEffect } from 'react';
import ControlPointOutlinedIcon from '@material-ui/icons/ControlPointOutlined';
import Styles from './Director.module.css';
import {
  getBusinessDirectorList,
  updateLAPPropertyAPI,
  getLAPPropertyAPI
} from '../../../../common/constants/api';
import { getApplicantionInfo } from '../../../../common/utils/applicantionInfo';
import PopUp from '../../../../common/components/PopUp/PopUp';
import * as _ from 'lodash';
import Modal from '../../../../common/components/Modal/modal';
import CommonCheckbox from '../../../../common/components/CommonCheckBox/CommonCheckbox';
import CommonSelect from '../../../../components/Dashboard-res/CommonComponent/CommonSelect';
import CommonInput from '../../../../components/Dashboard-res/CommonComponent/CommonInput';
import { useFormikContext } from 'formik';
import ToggleSelect from '../../../../common/components/ToggleSelect/ToggleSelect';
import individual_icon from '../../../../images/icons/UserKycIcons/individual_icon.svg';
import company_icon from '../../../../images/icons/company_icon.svg';
import withErrorHandler from '../../../../hoc/withErrorHandler/withErrorHandler';

const { directorList, container } = Styles;
let CoOwnerList = {};
let CoOwnerUpdationList = {};

const DirectorLists = () => {
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    setFieldValue,
    setFieldTouched,
    setFieldError,
    validateForm
  } = useFormikContext();
  const [type, setType] = useState('loading');
  const [text, setText] = useState('Loading...');
  const [show, setShow] = useState(false);
  const [Directors, setDirectors] = useState([]);
  const [coOwners, setCoOwner] = useState([]);
  const [CoOwnerUpdation, setCoOwnerUpdationList] = useState({});
  const [moveDirectorToCoOwner, setMovemnetOfDirector] = useState({});

  const [addCoOwner, setActionAddCoOwner] = useState(false);
  const [callApi, setCallApi] = useState(true);
  useEffect(() => {
    setType('loading');
    setText('Loading Please Wait..');
    setShow(true);
    getLAPPropertyAPI(getApplicantionInfo().leadId)
      .then(res => {
        if (res.error) {
          throw new Error(res);
        }
        setShow(false);
        if (res?.coOwners != null && res?.coOwners != undefined) {
          setCoOwner(res?.coOwners);

          res?.coOwners?.map((each, index) => {
            CoOwnerUpdationList[index.toString()] = each;
          });
          setCoOwnerUpdationList(CoOwnerUpdationList);
        }
        getDiectorList(res);
      })
      .catch(error => {
        setShow(true);
      });
  }, [callApi]);

  const handleAddedCoOwner = (res, coOwner) => {
    var unmovedcoOwner = [];
    if (!Array.isArray(res) || !Array.isArray(coOwner.coOwners)) {
      return;
    }
    let coOwnerData = coOwner.coOwners;
    for (let i = 0; i < res.length; i++) {
      for (let j = 0; j < coOwnerData.length; j++) {
        if (res[i]?.din == coOwnerData[j].dinNumber) {
          break;
        } else if (j == coOwnerData.length - 1) {
          unmovedcoOwner.push(res[i]);
        }
      }
    }

    setDirectors(unmovedcoOwner);
  };

  const getDiectorList = coOwner => {
    setType('loading');
    setText('Loading Please Wait..');
    setShow(true);
    getBusinessDirectorList(
      getApplicantionInfo().leadId,
      getApplicantionInfo().leadApplicantId
    )
      .then(res1 => {
        if (res1.error) {
          throw new Error(res1);
        }
        setShow(false);
        if (coOwner?.coOwners ? true : false) {
          handleAddedCoOwner(res1, coOwner);
        } else {
          setDirectors(res1);
        }
      })
      .catch(error => {
        setShow(true);
      });
  };
  useEffect(() => {
    if (addCoOwner) setFieldValue('isCoOwnerAdding', true);
    else setFieldValue('isCoOwnerAdding', false);
  }, [addCoOwner]);

  const handleSubmittion = () => {
    setType('loading');
    setText('Adding Co-Owner...');
    setShow(true);

    const AddCoOwners = data => {
      return {
        name: data?.name ? data.name : data?.fullName,
        relationship: data?.relationship || '',
        dinNumber: data?.din ? data.din : data.dinNumber,
        panNumber: data?.panNumber || '',
        designation: data?.designation || '',
        address: data?.address || ''
      };
    };
    let coOwners = [];
    for (let i = 0; i < Object.keys(moveDirectorToCoOwner).length; i++) {
      let data = Object.keys(moveDirectorToCoOwner)[i];
      coOwners.push(AddCoOwners(moveDirectorToCoOwner[data]));
    }
    for (let i = 0; i < Object.keys(CoOwnerUpdation).length; i++) {
      let data = Object.keys(CoOwnerUpdation)[i];
      coOwners.push(AddCoOwners(CoOwnerUpdation[data]));
    }

    let body = {
      coOwners: coOwners
    };
    updateLAPPropertyAPI(getApplicantionInfo().leadId, body)
      .then(res => {
        setShow(false);
        handleSubmit();
      })
      .catch(error => {
        setShow(false);
      });
  };

  return (
    <div className="w-12/12 mr-auto px-6 my-1">
      <div className="w-full flex mt-16">
        <div className="font-roboto font-medium text-sm text-black-850 mr-auto">
          List of Directors
        </div>
        <div className="float-right" onClick={e => setActionAddCoOwner(true)}>
          <button
            type="button"
            className="rounded bg-orange-650 font-roboto font-normal bg-opacity-50 text-center px-4 py-2 flex text-orange-600 text-sm items-center"
          >
            <ControlPointOutlinedIcon
              style={{
                color: '#FF8000',
                fontSize: '15px',
                marginLeft: '3px',
                marginRight: '3px'
              }}
            />{' '}
            Co- Owner
          </button>
        </div>
      </div>
      <div className="w-full overflow-auto my-5 flex flex-wrap">
        {coOwners.map((each, index) => (
          <DirectorData
            data={each}
            key={index}
            index={index}
            dataList={CoOwnerUpdationList}
            coOwner={true}
            updationOfCoOwner={setCoOwnerUpdationList}
          />
        ))}
      </div>
      <div className="w-full overflow-auto my-5 flex flex-wrap">
        {Directors.map((each, index) => (
          <DirectorData
            data={each}
            key={index}
            index={index}
            dataList={CoOwnerList}
            updationOfCoOwner={setMovemnetOfDirector}
          />
        ))}
      </div>
      <div className="w-full">
        {Directors.length == 0 && coOwners.length == 0 ? (
          <div className="font-roboto font-normal text-base text-black-500 text-center">
            No co-owner available! please add co-owner
          </div>
        ) : null}
      </div>
      <button
        type="button"
        className="submitButton fonåt-roboto text-white text-base w-48 "
        onClick={handleSubmittion}
      >
        NEXT
      </button>

      <PopUp type={type} text={text} setShow={setShow} show={show} />
      <Modal
        show={addCoOwner}
        setShow={setActionAddCoOwner}
        styleContainer={{
          width: '100%',
          maxWidth: '450px',
          marginLeft: 'auto',
          marginRight: 'auto'
        }}
        title="Add Co-Owner"
      >
        <AddCoOwner
          setFieldValue={setFieldValue}
          handleBlur={handleBlur}
          values={values}
          errors={errors}
          touched={touched}
          handleChange={handleChange}
          validateForm={validateForm}
          handleSubmit={handleSubmit}
          setActionAddCoOwner={setActionAddCoOwner}
          CoOwnerUpdation={CoOwnerUpdation}
          moveDirectorToCoOwner={moveDirectorToCoOwner}
          setCallApi={setCallApi}
          callApi={callApi}
        />
      </Modal>
    </div>
  );
};
export default withErrorHandler(DirectorLists);

const DirectorData = ({
  data,
  index,
  dataList,
  coOwner,
  updationOfCoOwner
}) => {
  const [isChecked, setChecked] = useState(coOwner);
  const dagtaContainer = 'md:w-3/12 md:block w-full flex my-1';
  const labelField =
    'font-roboto font-nomal text-sm text-grey-1003 text-left w-7/12 md:w-full';
  const DataFiled =
    'font-roboto font-medium text-sm  text-black-400 text-left w-5/12 md:w-full';
  return (
    <div className="px-3 flex xl:w-6/12 lg:w-full w-full">
      <div className="mt-3">
        <CommonCheckbox
          checked={isChecked || false}
          name="director"
          value={isChecked}
          onChange={e => {
            if (!isChecked) {
              dataList[index.toString()] = data;
            } else if (isChecked) {
              index.toString() in dataList
                ? delete dataList[index.toString()]
                : null;
            }
            updationOfCoOwner(dataList);

            setChecked(!isChecked);
          }}
        />
      </div>
      <div
        className={` bg-orange-200  rounded my-3 pl-1 w-full -ml-3 ${container}`}
      >
        <div className="w-full md:bg-navy-700 bg-white px-3 py-5 h-full ">
          <div className="w-full my-6 md:my-3">
            <div className="flex flex-wrap">
              <div className={`${dagtaContainer} ${directorList}`}>
                <p className={`${labelField}`}>Full Name</p>
                <p className={`${DataFiled}`}>
                  <span className="md:hidden mx-1">:</span>
                  {_.get(data, coOwner ? 'name' : 'fullName', false)
                    ? _.get(data, coOwner ? 'name' : 'fullName', '---')
                    : '---'}
                </p>
              </div>
              {data?.relationship ? (
                <div className={`${dagtaContainer} ${directorList}`}>
                  <p className={`${labelField}`}>Relationship</p>
                  <p className={`${DataFiled}`}>
                    <span className="md:hidden mx-1">:</span>{' '}
                    {_.get(data, 'relationship', false)
                      ? _.get(data, 'relationship', '---')
                      : '---'}
                  </p>
                </div>
              ) : (
                <React.Fragment>
                  <div className={`${dagtaContainer} ${directorList}`}>
                    <p className={`${labelField}`}>DIN Number</p>
                    <p className={`${DataFiled}`}>
                      <span className="md:hidden mx-1">:</span>{' '}
                      {_.get(data, coOwner ? 'dinNumber' : 'din', false)
                        ? _.get(data, coOwner ? 'dinNumber' : 'din', '---')
                        : '---'}
                    </p>
                  </div>
                  <div className={`${dagtaContainer} ${directorList}`}>
                    <p className={`${labelField}`}>Designation</p>
                    <p className={`${DataFiled}`}>
                      <span className="md:hidden mx-1">:</span>{' '}
                      {_.get(data, 'designation', false)
                        ? _.get(data, 'designation', '---')
                        : '---'}
                    </p>
                  </div>{' '}
                  <div className={`${dagtaContainer} ${directorList}`}>
                    <p className={`${labelField}`}>DSC registered</p>
                    <p className={`${DataFiled}`}>
                      <span className="md:hidden mx-1">:</span>{' '}
                      {_.get(data, 'dscRegistered', false) ? 'yes' : 'No'}
                    </p>
                  </div>{' '}
                  <div className={`${dagtaContainer} ${directorList}`}>
                    <p className={`${labelField}`}>Date of Appointment</p>
                    <p className={`${DataFiled}`}>
                      <span className="md:hidden mx-1">:</span>
                      {_.get(data, 'appointmentDate', '---')
                        ? _.get(data, 'appointmentDate', '---')
                        : '---'}
                    </p>
                  </div>{' '}
                </React.Fragment>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const AddCoOwner = ({
  setFieldValue,
  handleBlur,
  values,
  errors,
  touched,
  handleChange,
  validateForm,
  handleSubmit,
  setActionAddCoOwner,
  CoOwnerUpdation,
  moveDirectorToCoOwner,
  setCallApi,
  callApi
}) => {
  const [type, setType] = useState('loading');
  const [text, setText] = useState('Loading...');
  const [show, setShow] = useState(false);

  const commonInputEffect = { height: '52px', maxWidth: '100%' };
  const comonSelectContainerEffect = {
    minHeight: '52px',
    marginBottom: '0px',
    fontSize: '40px',
    alignItems: 'center'
  };
  const commonDropDownStles = {
    top: '52px',
    color: 'rgba(0,0,0,0.87)',
    fontSize: '16px',
    backgroundColor: '#fff',
    alignItems: 'center',
    fontFamily: 'Roboto',
    fontWeight: 400
  };

  const selectCommonDisplay = {
    fontSize: '14px',
    padding: '0 25px',
    alignItems: 'center',
    minHeight: '52px'
  };
  const RelationList = [
    {
      label: 'Father',
      value: 'Father'
    },
    {
      label: 'Son',
      value: 'Son'
    },
    {
      label: 'Mother',
      value: 'Mother'
    }
  ];
  const commonInputstyle = 'w-6/12 px-3 my-3';

  const AddCoOwners = data => {
    return {
      name: data?.name ? data.name : data?.fullName,
      relationship: data?.relationship || '',
      dinNumber: data?.din ? data.din : data.dinNumber,
      panNumber: data?.panNumber || '',
      designation: data?.designation || '',
      address: data?.address || ''
    };
  };
  const handleAddCoOwner = () => {
    setType('loading');
    setText('Adding Co-Owner...');
    setShow(true);
    let coOwners = [];
    for (let i = 0; i < Object.keys(moveDirectorToCoOwner).length; i++) {
      let data = Object.keys(moveDirectorToCoOwner)[i];
      coOwners.push(AddCoOwners(moveDirectorToCoOwner[data]));
    }
    for (let i = 0; i < Object.keys(CoOwnerUpdation).length; i++) {
      let dataOther = Object.keys(CoOwnerUpdation)[i];
      coOwners.push(AddCoOwners(CoOwnerUpdation[dataOther]));
    }
    coOwners.push({
      name: `${values.firstName} ${values.lastName}`,
      relationship: values.relation.label,
      dinNumber: '',
      panNumber: '',
      designation: '',
      address: ''
    });
    let body = {
      coOwners: coOwners
    };

    updateLAPPropertyAPI(getApplicantionInfo().leadId, body)
      .then(res => {
        setShow(false);
        setCallApi(!callApi);
      })
      .catch(error => {
        setShow(false);
      });
  };
  const handleSubmition = () => {
    validateForm().then(res => {
      if (Object.keys(res).length == 0) {
        handleAddCoOwner();
        setActionAddCoOwner(false);
      } else {
        handleSubmit();
      }
    });
  };

  return (
    <div className="mt-2 w-full">
      <hr style={{ color: '#DCE9F5', height: '1px' }} className="" />
      <div className="w-full mt-7 mb-4 px-2 flex flex-wrap ">
        <div className={`${commonInputstyle}`}>
          <CommonInput
            name="firstName"
            onBlur={handleBlur}
            value={values.firstName}
            stylesContainer={commonInputEffect}
            legendName="First Name"
            error={touched.firstName && errors.firstName}
            errorMsg={errors.firstName}
            touched={touched.firstName}
            onChange={handleChange}
          />
        </div>
        <div className={`${commonInputstyle}`}>
          <CommonInput
            name="lastName"
            onBlur={handleBlur}
            value={values.lastName}
            stylesContainer={commonInputEffect}
            legendName="Last Name"
            error={touched.lastName && errors.lastName}
            errorMsg={errors.lastName}
            touched={touched.lastName}
            onChange={handleChange}
          />
        </div>
        <div className={`${commonInputstyle}`}>
          <CommonSelect sort={true}
            name="relation"
            value={values.relation}
            onChange={e => {
              setFieldValue('relation', {
                value: e.value,
                label: e.label
              });
            }}
            options={RelationList}
            isHoverEffect
            stylesContainer={comonSelectContainerEffect}
            dropdownStyle={commonDropDownStles}
            styleText={selectCommonDisplay}
            error={touched.relation && _.get(errors, 'relation.value', false)}
            touched={touched.relation}
          />
        </div>
      </div>
      <button
        type="button"
        className="submitButton font-roboto text-white text-base w-48 "
        disabled={Object.keys(errors).length != 0 ? true : false}
        onClick={handleSubmition}
      >
        ADD
      </button>
      <PopUp type={type} text={text} setShow={setShow} show={show} />
    </div>
  );
};

const CoOwnerPropertType = ({ values, setFieldValue }) => {
  return (
    <div className="w-full my-4">
      <p className="font-roboto font-medium trext-black-850 text-sm mb-1">
        Property Co- Owner
      </p>
      <div className="flex my-4">
        <ToggleSelect
          img={individual_icon}
          name="applyLoanAs"
          value="Individual"
          checked={values.applyLoanAs === 'Individual'}
          onChange={async e => {
            await setFieldValue('applyLoanAs', e.target.value);
          }}
          addClasses="cursor-pointer hover:bg-green-100 hover:border-green-1000"
          containerStyle={{
            width: '7.5rem',
            height: '100px',
            marginRight: '20px'
          }}
          nameDisplay="Individual"
          namingStyle={{
            paddingTop: '40px',
            color: values.applyLoanAs === 'Individual' ? '#00ACB8' : '#545454DE'
          }}
        />
        <ToggleSelect
          img={company_icon}
          name="applyLoanAs"
          value="Company"
          checked={values.applyLoanAs === 'Company'}
          onChange={e => {
            setFieldValue('applyLoanAs', e.target.value);
          }}
          addClasses="cursor-pointer hover:bg-green-100 hover:border-green-1000"
          containerStyle={{
            width: '7.5rem',
            height: '100px'
          }}
          nameDisplay="Company"
          namingStyle={{
            paddingTop: '40px',
            color: values.applyLoanAs === 'Company' ? '#00ACB8' : '#545454DE'
          }}
        />
      </div>
    </div>
  );
};
